import { render, staticRenderFns } from "./ListaAdministrador.vue?vue&type=template&id=a4635e42&scoped=true"
import script from "./ListaAdministrador.vue?vue&type=script&lang=js"
export * from "./ListaAdministrador.vue?vue&type=script&lang=js"
import style0 from "./ListaAdministrador.vue?vue&type=style&index=0&id=a4635e42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4635e42",
  null
  
)

export default component.exports